import { NgModule } from '@angular/core';

import { TimepickerComponent } from './timepicker.component';

@NgModule({
    imports: [TimepickerComponent],
    exports: [TimepickerComponent],
})
export class TimepickerModule {}
